import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import config from '../config.json';
import { strings } from '../localization';
import { redirect } from 'react-router';
import UAParser from 'ua-parser-js';
import { useIndexedDB } from 'react-indexed-db';


axios.defaults.baseURL = config.baseURL;

function useApi(){
    const { update, getAll } = useIndexedDB('catalog');
    
    useEffect( () => {

        let foundUser = localStorage.getItem('user');
        if(foundUser)
        setUser(JSON.parse(foundUser))

    }, [])

    
    
    const newUser =  {
        isLoggedIn: false,
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        order_num: 1000,
        customer_num: 1000,
        contact_num: 1000,
        address_num: 1000,
        token: null,
        ref: '',
        display_name: '',
        bannerImage: null
    }

    const setUser = (user) => {
        localStorage.setItem('user',JSON.stringify(user))
        axios.defaults.headers.common['Authorization'] = `Bearer ${user.token}`;
        _setUser(user)
    }
    const [user, _setUser] = useState();
    const [errors, setErrors] = useState([]);
    
    const setNewUser = () => {
        setUser(newUser)
    }
    const fetchApi = (path, params = {}, data= {}, method = "post") => {

        let headers = { 'Content-Type': 'application/json' }
        params.version = process.env.REACT_APP_VERSION
        let parser = new UAParser(window.navigator.userAgent);
        params.os = parser.getOS();
        params.browser = parser.getBrowser(); 
       

        return axios({
            method: method,
            url: path,
            params: params,
            data: data,
            headers: headers
        })        
        .catch(handleApiError)
        .then(response => response)

    }
    

    const fetchImage = (path, params = {}, callBack = (response) => {}) => {

        
        axios.post(path, params)
        .then(callBack)
        .catch(handleApiError);   

    }


    const handleApiError = (error) => {

        console.log(error)

        if(error.hasOwnProperty('response') && error.response.hasOwnProperty('data') && error.response.data.message)
        setErrors([error.response.data.message]);
        else
        setErrors([ strings.api_fail ]);

        switch (error.response?.status) {
            case 401:      
            handleLogout();            
            break;

        }


    }



    const handleLogin = (username, password) => {  
        
        

        let params = { username: username, password : password, version : process.env.REACT_APP_VERSION };  
        let parser = new UAParser(window.navigator.userAgent);
        params.os = parser.getOS();
        params.browser = parser.getBrowser(); 
        let headers = { 'Content-Type': 'application/json' }

        // GET TOKEN
        axios.post('/login_check', params, { headers: headers })
        .then(response => {

            let token = response.data.token
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            
            // GET USER INFO
            fetchApi('/user').then( response => {

                let loggedInUser = { ...newUser, ...response.data, isLoggedIn: true, token:  token}

                // isLoggedIn : true,
                // firstName : response.data.firstName,
                // lastName : response.data.lastName,
                // phone : response.data.phone,
                // email : response.data.email

                setUser(loggedInUser); 

                
                
              
            })

            
        })
        .catch( handleApiError );

    }

  


    const handleLogout = () => {    
        
        setUser(newUser)
        localStorage.removeItem('user')
        sessionStorage.clear();
        setErrors([])
        
    }

    const [customers, setCustomers] = useState([]);
    useEffect(() => {
        getAll().then(dataFromDB => {
            setCustomers(dataFromDB.find(i => i.type == 'customers')?.data ?? []);
        });
    }, []);

    const updateFavoriteProducts = (selectedClient) => {
        fetchApi(
            '/update_favorite_products', 
            {}, 
            {
                'client': selectedClient.ref,
                'favorite_products': selectedClient.favorite_products,
            }, 
            'POST'
        ).then( response => {
            let updatedCustomers = customers.map(c => 
                c.ref === selectedClient.ref ? selectedClient : c
            );

            update({type: 'customers', data: updatedCustomers}).then(event => {
                return updatedCustomers;
            });
        });
    }

    const updateExcludedCategories = (selectedClient) => {
        fetchApi(
            '/update_excluded_categories', 
            {}, 
            {
                'client': selectedClient.ref,
                'excluded_categories': selectedClient.excluded_categories,
            }, 
            'POST'
        ).then( response => {
            let updatedCustomers = customers.map(c => 
                c.ref === selectedClient.ref ? selectedClient : c
            );

            update({type: 'customers', data: updatedCustomers}).then(event => {
                return updatedCustomers;
            });
        });
    }

    return [        
        user,
        {
        'setUser': setUser,
        'setNewUser': setNewUser,
        'setErrors': setErrors,
        'logout': handleLogout,
        'login': handleLogin,
        'fetchAPI': fetchApi,
        'fetchImage': fetchImage,
        'updateFavoriteProducts': updateFavoriteProducts,
        'updateExcludedCategories': updateExcludedCategories,
        'errors' : errors,
        }  
    ]

}

export { useApi };
